// This file is automatically generated by git.version.js script
export const versions = {
  repo: 'https://github.com/K-Fet/K-App',
  version: '2.3.6',
  revision: '5f7bc44d',
  branch: 'HEAD',
  buildDate: 1621332066000,
};
